import {FC} from "react";
import {TeamSpace, TeamSpaceItem} from "../../../../../lib/src/api/repositories/documentation-library-repository";
import {useDocumentationLibraryContext} from "@jane/lib/src/components/tiptap/context/DocumentationLibraryContext";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faHouse} from "@fortawesome/pro-solid-svg-icons";
import {faEllipsis, faFile} from "@fortawesome/pro-regular-svg-icons";
import {ContextMenuPortal} from "../portals/ContextMenuPortal";
import {DeletePageModal} from "../../../../../lib/src/components/tiptap/components/modals/DeletePageModal";
import {config} from "../../../config";
import {EditPageModal} from "../../../modals/documentation/EditPageModal";

export const TeamSpacePageRow: FC<{ space: TeamSpace, item: TeamSpaceItem, indentLevel?: number }> = ({ space, item, indentLevel = 0}) => {
  const { page, selectPage, onSpacesUpdated, getPages, onPageDeleted, canEdit } = useDocumentationLibraryContext();

  const editPageModal = useModal({title: "Pagina bewerken", body: <EditPageModal item={item} onFinished={() => { onSpacesUpdated();getPages(item.teamSpaceId) }} />, size:'md'})
  const deletePageModal = useModal({title: "Pagina Verwijderen", body: <DeletePageModal item={item} onDeleted={onPageDeleted} config={config}/>, size:'md'})

  return <div style={{paddingLeft: `calc(1rem + ${indentLevel*20}px)`}} className={`flex flex-row items-center justify-between my-1 px-2 py-1 ${item.id === page?.id ? "bg-brand-50" : ""} hover:bg-brand-50 rounded-sm group`}
              onClick={() => selectPage(item.id)}>
    <div className={`flex flex-1 flex-row space-x-4 items-center `}>
      <div className={'text-brand-secondary'}>
        <FontAwesomeIcon icon={item.isDefault ? faHouse : faFile} />
      </div>
      <div className={'text-sm truncate'}>{item.name}</div>
    </div>
    {canEdit(space) && <div className={'flex flex-row space-x-1 text-sm invisible group-hover:visible'}>
      <ContextMenuPortal trigger={
        <div className="py-0.5 px-0.5 bg-brand-50 hover:bg-brand-100 rounded-sm">
          <FontAwesomeIcon icon={faEllipsis}/>
        </div>
      } onEditItem={editPageModal.open} onDeleteItem={deletePageModal.open}/>
    </div>}
  </div>
}